import Vue from "vue";
import Vuex from "vuex";
import user, { userVuexPersistence } from "./modules/user"


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user
  },
  plugins: [
    userVuexPersistence().plugin
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js